/**
 * Paleta validada (contraste + ΔE en modo daltónico) para series categóricas y
 * de estado sobre el fondo oscuro de GOVIA. Ver skill `dataviz` para la metodología.
 */
export const CATEGORICAL_COLORS = [
  '#3987e5', // azul
  '#d95926', // naranja
  '#199e70', // aqua
  '#c98500', // amarillo
  '#d55181', // magenta
  '#008300', // verde
  '#9085e9', // violeta
  '#e66767', // rojo
] as const

export const STATUS_COLORS = {
  good: '#0ca30c',
  warning: '#fab219',
  serious: '#ec835a',
  critical: '#d03b3b',
} as const

export const CHART_GRID_COLOR = '#2c2c2a'
export const CHART_AXIS_COLOR = '#898781'

export function seriesColor(index: number): string {
  return CATEGORICAL_COLORS[index % CATEGORICAL_COLORS.length] as string
}

export function riskColor(level: string): string {
  const key = level.toLowerCase()
  if (key === 'critical' || key === 'crítico') return STATUS_COLORS.critical
  if (key === 'high' || key === 'alto') return STATUS_COLORS.serious
  if (key === 'medium' || key === 'medio') return STATUS_COLORS.warning
  return STATUS_COLORS.good
}
